import React, {
	useEffect, useState
}from "react"
import {
	Empty, Select, Spin
}from "antd"
import {
	useDispatch, useSelector
}from "react-redux"
import {
	useDebounce
}from "use-lodash-debounce"
import "antd/lib/select/style/index.css"
import "antd/lib/spin/style/index.css"
import "antd/lib/empty/style/index.css"
import {
	reOrgActions
}from "./actions"
import Notifications from "../../../helpers/Notifications"
import i18n from "../localization"
import {
	CustomSelect
}from "../../../components/CustomSelect"

import "./style.css"
const { Option } = Select

const SelectRegisteredOrg = (props) => {
	const { value, onChange, placeHolder, initialValues, disabled, mode = "false", maxTagCount = false, needClear = true, isForAppealForm = false } = props
	const [initialData, setInitialData] = useState(initialValues)
	const [focusOnField, setFocusOnField] = useState(false)
	const [orgId, setOrg] = useState([])
	const dispatch = useDispatch()
	const isRu = useSelector((state) => state.globalReducer.isRu)
	const {
		minReOrgByNameOrUNP,
		minReOrgSending,
		isRegistered
	} = useSelector((state) => state.reOrgReducer)
	const [orgName, setOrgName] = useState("")
	const searchValue = useDebounce(orgName, 500)

	useEffect(() => {
		return () => {
			if (needClear)
				dispatch(reOrgActions.clearMinReOrgByNameOrUNP())
			dispatch(reOrgActions.isRegisteredClear())
		}
	}, [])

	useEffect(() => {
		if (needClear)
			dispatch(reOrgActions.clearMinReOrgByNameOrUNP())
		dispatch(reOrgActions.isRegisteredClear())
	}, [initialValues])

	// useEffect(() => {
	// 	if (isParentChecked){
	// 		dispatch(reOrgActions.getMinReOrgByNameOrUNP({
	// 			name              : "",
	// 			pageSize          : 30,
	// 			parentId          : parentId,
	// 			"orgTypeCodes[0]" : 1,
	// 			"orgTypeCodes[1]" : 3,
	// 			"orgTypeCodes[2]" : 4
	// 		}))
	// 	}
	// 	else {
	// 		//dispatch(reOrgActions.clearMinReOrgByNameOrUNP())

	// 		dispatch(reOrgActions.isRegisteredClear())
	// 	}
	// }, [isParentChecked])

	useEffect(() => {
		getReOrgsByName(searchValue)
	}, [searchValue])

	useEffect(() => {
		if (isRegistered !== null && focusOnField){
			switch (isRegistered){
				case "Active": {
					const selectedValue = minReOrgByNameOrUNP?.find((org) => {
						return org.id == orgId
					})
					if (selectedValue){
						if (value && mode === "multiple")
							onChange([...value, selectedValue])
						else
							onChange([selectedValue])
					}
					break;
				}
				case "NotActive": {
					Notifications.errorNotice(i18n.orgNotActive[isRu], null, 10)
					break;
				}
				case "NoUsers": {
					Notifications.errorNotice(i18n.orgHasNoUsers[isRu], null, 10)
					break;
				}
				case "NoWorkShedule": {
					Notifications.errorNotice(i18n.orgHasNoWorkShedule[isRu], null, 10)
					break;
				}
				default: {
					Notifications.errorNotice(i18n.undefinedError[isRu], null, 10)
					break;
				}
			}
			dispatch(reOrgActions.isRegisteredClear())
		}
	}, [isRegistered])

	function getReOrgsByName(name){
		if (name?.length > 3){
			
			dispatch(
				isForAppealForm
				? reOrgActions.getReOrgsForApllicantsList({
					search        : name
				})
				: reOrgActions.getMinReOrgByNameOrUNP({
					name              : name,
					pageSize          : 30,
					parentId          : 0,
					// parentId          : isParentChecked ? parentId : 0,
					"orgTypeCodes[0]" : 1,
					"orgTypeCodes[1]" : 3,
					"orgTypeCodes[2]" : 4,
					"orgTypeCodes[3]" : 5
				})
			)
		}
	}

	function onSelect(reOrgId){
		setInitialData(null)
		setOrg(reOrgId)
		if(maxTagCount){
			if(!value || value.length<maxTagCount){
				dispatch(reOrgActions.checkReOrgIsRegistered({ ReOrgId: reOrgId }))
			}else
				Notifications.errorNotice(i18n.maxReOrgCountNotification[isRu].replace("{0}", maxTagCount), null, 10)
		} else {
			dispatch(reOrgActions.checkReOrgIsRegistered({ ReOrgId: reOrgId }))
		}
	}

	function onDeselect(reOrgId){
		setInitialData(null)
		if (reOrgId){
			const selectedValues = value.filter((org) => {
				return org.id != reOrgId
			})
			onChange(selectedValues)
		}
	}

	return (
		<>
			<CustomSelect
				showSearch
				className="selectRegisteredOrg"
				disabled={ disabled }
				filterOption={ false }
				getPopupContainer={ trigger => trigger.parentNode }
				mode={ mode }
				maxTagCount={maxTagCount}
				notFoundContent={
					minReOrgSending ? <Spin size="small" /> : <Empty description={ i18n.orgSearchNotFound[isRu] } />
				}
				placeholder={ placeHolder }
				style={ { height: "auto" } }
				value={ value ? value.map((x) => x.id) : [] }
				onDeselect={ !disabled ? onDeselect : null }
				onInputKeyDown={ !disabled ? false : (e) => {
					e.preventDefault(); return
				} }
				onSearch={ (value) => (!disabled ? setOrgName(value) : null) }
				onSelect={ !disabled ? onSelect : null }
				onFocus={() => setFocusOnField(true)}
          		onBlur={() => setFocusOnField(false)} 
			>
				{ minReOrgByNameOrUNP
					? minReOrgByNameOrUNP.map((org, index) => {
						return (
							<Option
								key={ index }
								title={ `${org.unp ? `(УНП ${org.unp})`: ""} ${isRu ? org.fullName : (org.fullNameBel ? org.fullNameBel : org.fullName)}`.trim() }
								value={ org.id }
								className="optionsWithFullOrgName"
							>
								<span>{ isRu ? org.fullName : (org.fullNameBel ? org.fullNameBel : org.fullName) }</span>
							</Option>
						)
					})
					: initialData?.map((org, index) => {
						return (
							<Option
								key={ index }
								title={ isRu ? org.fullName : (org.fullNameBel ? org.fullNameBel : org.fullName) }
								value={ org.id }
								className="optionsWithFullOrgName"
							>
								<span >{ isRu ? org.fullName : (org.fullNameBel ? org.fullNameBel : org.fullName) }</span>
							</Option>
						)
					}) }
			</CustomSelect>
		</>
	)
}

export default SelectRegisteredOrg
